import ClientBase from "Services/API/ClientBase";

export interface CropRequest {
   ImgW: number,
   ImgH: number,
   ImgY1: number,
   ImgX1: number,
   CropH: number,
   CropW: number,
   Angle: number,
   RotateAfterCrop: boolean
}
export interface SaveImageResponse {
   caption?: string | null
   height?: number
   id?: Guid,
   status: "success" | "fail"
   success: boolean
   tag?: string | null
   thumbnailUrl?: string | null
   url?: string | null
   width?: number
}
export class PictureClient extends ClientBase {
   protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

   constructor() {
      super();
   }

   async saveImage(pictureDbOwnerId: Guid, qqfile: File | null, pictureType: LSCommon.Enums.PictureTypeEnum, tags: string,
      pictureId?: Guid, cropRequest?: CropRequest, isPrecreation = false, pictureDbOwnerParentId?: Guid): Promise<SaveImageResponse> {
      const data = new FormData();
      data.append("pictureDbOwnerId", pictureDbOwnerId);
      qqfile && data.append("qqfile", qqfile);
      data.append("pictureType", pictureType.toString());
      data.append("tags", tags);
      if(cropRequest) {
         for (const key in cropRequest) {
            data.append("cropRequest." + key, cropRequest[key]);
         }
      }

      pictureId && data.append("pictureId", pictureId);
      isPrecreation && data.append("isPrecreation", isPrecreation.toString());
      pictureDbOwnerParentId && data.append("pictureDbOwnerParentId", pictureDbOwnerParentId);

      const url_ = "/Picture/SaveImage";
      return fetch(url_, { method: "POST", body: data, headers: { "X-Requested-With": "XMLHttpRequest" } }).then((_response: Response) => {
         return this.transformResult(url_, _response, (_response: Response) => _response.json() as Promise<SaveImageResponse>);
      });
   }

   async deletePicture(pictureDbOwnerId: Guid, pictureId: Guid, pictureType: LSCommon.Enums.PictureTypeEnum, pictureDbOwnerParentId?: Guid) {
      const url_ = "/Picture/DeletePicture";
      return fetch(url_, {
         method: "POST", headers: {
            "Content-Type": "application/json"
         },
         body: JSON.stringify({ pictureDbOwnerId, pictureId, pictureType, pictureDbOwnerParentId })
      }).then((_response: Response) => {
         return this.transformResult(url_, _response, (_response: Response) => _response.json() as Promise<boolean>);
      });
   }
}